import React from 'react';
import PropTypes from 'prop-types';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography, List, ListItem, ListItemText } from '@mui/material';

const ErrorDialog = ({ open, onClose, errorData }) => {
    if (!errorData) return null;

    return (
        <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
            <DialogTitle>Import Errors</DialogTitle>
            <DialogContent>
                <Typography variant="body1" paragraph>
                    {errorData.message}
                </Typography>
                <List>
                    {errorData.errors.map((error, index) => (
                        <ListItem key={index}>
                            <ListItemText primary={error} />
                        </ListItem>
                    ))}
                </List>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>Close</Button>
            </DialogActions>
        </Dialog>
    );
};

ErrorDialog.propTypes = {
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    errorData: PropTypes.shape({
        message: PropTypes.string.isRequired,
        errors: PropTypes.arrayOf(PropTypes.string).isRequired
    })
};

export default ErrorDialog;

